import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

export default function Settings() {
  const { user } = useAuth();
  return (
    <div className="space-y-3 animate-fade-in" data-testid="settings-page">
      <h1 className="font-heading text-2xl md:text-3xl">Settings</h1>
      <Card className="border-[#E8E3DF]">
        <CardContent className="p-5 space-y-4">
          <div className="flex items-center gap-4">
            <Logo size={64} />
            <div>
              <div className="font-heading text-xl">The Palate Stories</div>
              <div className="text-sm text-[#4B5563]">Patisserie & Bake Studio · Narayan Peth, Pune</div>
            </div>
          </div>
          <div className="border-t border-[#E8E3DF] pt-4">
            <div className="text-xs uppercase tracking-wider text-[#4B5563] mb-2">Signed in as</div>
            <div className="text-sm"><strong>{user?.name}</strong> · @{user?.username} · <span className="capitalize">{user?.role}</span></div>
          </div>
          <div className="border-t border-[#E8E3DF] pt-4 text-xs text-[#4B5563] leading-relaxed">
            <p>Time is shown in 12-hour AM/PM format throughout the app. WhatsApp templates can be edited in the <em>WhatsApp Templates</em> screen (owner only). User accounts can be managed in <em>User Management</em>.</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
